import React, { useState } from "react";
import {
	PayoutNotification,
	Payouts,
	RecentActivity,
	Modal,
} from "../../../components";
import EditPayout from "../../../components/Modal/Update/EditPayout.jsx";
import DeletePayout from "../../../components/Modal/Trash/DeletePayout.jsx";
import helperService from "../../../services/helper.service.js";
import { csvSchema } from "../../../schema/index.js";

function Notification() {
	const [showModal, setShowModal] = useState(false);
	const [modalContent, setModalContent] = useState(null);

	const handleEditPayout = (payout) => {
		setShowModal(true);
		setModalContent(
			<EditPayout
				payout={payout}
				title="Edit Payout"
				onClose={() => setShowModal(false)}
			/>
		);
	};

	const handleDeletePayout = (payout) => {
		setShowModal(true);
		setModalContent(
			<DeletePayout
				payout={payout}
				title="Delete Payout"
				onClose={() => setShowModal(false)}
			/>
		);
	};

	const handleExport = (allPayouts) => {
		const csvString = helperService.convertArrayToCSV(allPayouts, csvSchema);
		const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
		const url = URL.createObjectURL(blob);
		const link = document.createElement("a");
		link.href = url;

		link.setAttribute("download", "event-app-payouts.csv");
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	};

	return (
		<>
			<section className="flex flex-col gap-10 px-[30px] md:min-h-[97%] min-h-[100vh] pt-[10px] pb-[60%] md:pb-[30px] overflow-auto">
				<PayoutNotification />
				<Payouts
					handleExport={handleExport}
					handleEditPayout={handleEditPayout}
					handleDeletePayout={handleDeletePayout}
				/>
				<RecentActivity />
			</section>

			{showModal && <Modal modalContent={modalContent} />}
		</>
	);
}

export default Notification;
